import { GameInitData } from '../../types';
import {
    getBTCBetLimits,
    getBTCCurrencyAttributes,
    getBalance,
    getCustomBTCParams,
    getCustomParams,
    getRandomNonBonusBallColor,
    getTopSlotWinTypes,
    getUSDTCurrencyAttributes
} from './helper';

const isBTC = true;

export const localInitData: GameInitData = {
    balance: getBalance(),
    config: {
        rtp: '95',
        bet_limits: getBTCBetLimits(),
        default_bet: 100000000,
        popular_bet: 200000000,
        purchased_features: [],
        casino_id: 'clawbastards',
        hide_home_button: false
    },
    state: {
        round: 'string', // предыдуший раунд
        resp: {
            win: true, // выигрыш или нет
            top_slot: {
                // параметры топ слота
                types: getTopSlotWinTypes(),
                type: 'BALL_SPIN',
                multipliers: ['1', '2', '3', '4', '5', '7', '10', '15', '20', '25', '50'],
                multiplier: '7'
            },
            color: getRandomNonBonusBallColor(), // цвет вытянутого шара, null - если не вытянула
            game_type: 'CRAZY_CRAZY_CLAW',
            win_amount: 12345,
            win_type: 'EPIC',
            ball_type: ''
        },
        final: true // если false - надо сразу переходить к бонуске из state.resp
    },
    currency_attributes: isBTC ? getBTCCurrencyAttributes() : getUSDTCurrencyAttributes(),
    custom_params: isBTC ? getCustomBTCParams() : getCustomParams()
};
